import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';

export const getUSStates = async (): Promise<{ label: string; code: string }[]> => {
  const { data } = await api.get<TCustomAxiosResponse<{ label: string; code: string }[]>>(apiPaths.meta.usStates);
  const states = data.data;

  return states;
};
